import _ from 'lodash';

export default {
    returnIndexOfDuplicateHistory(history, code) {
        return _.findIndex(history, {
            code: code
        })
    },
    checkIsMoreThan15HistoryItems(history) {
        return history.length >= 15;
    },
    setHistoryToLocalStorage(history) {
        localStorage.setItem("userHistory", JSON.stringify(history));
    },
    getHistoryFromLocalStorage() {
        return JSON.parse(localStorage.getItem("userHistory"));
    },
}
